import { delay } from 'redux-saga';
import { all, call, put } from 'redux-saga/effects';
import FullSearchAction from '../Redux/FullSearch';


export function* getFullSearchResult(api, action) {
    if (!action.args.searchKey.trim()) return;
    
    // make the call to the api
    let { searchKey, activedType, pageNum } = action.args;
    const splitterIndex = searchKey.indexOf(">");

    if (splitterIndex != -1) {
        const tag = searchKey.substr(0, splitterIndex).trim();
        const text = searchKey.substring(splitterIndex + 1).trim();
        searchKey = `${tag ? `+"${tag}"` : ""} ${text ? `+${text}` : ""}`;
        searchKey = searchKey.trim();
    }

    // if(!activedType) {
    //     const response = yield call(api.searchAll, searchKey, pageNum + 1);
    //     if (response.ok) {
    //         yield put(FullSearchAction.fullFetchResult(response.data));
    //     } else {}
    // } else {
    //     const ONLY_STAT_PAGE_NUM = 1;
    //     const ONLY_STAT_PAGE_SIZE = 1;
    //     const [list, stat] = yield all([
    //         call(api.search, searchKey, activedType, pageNum + 1),
    //         call(api.searchAll, searchKey, ONLY_STAT_PAGE_NUM, ONLY_STAT_PAGE_SIZE)
    //     ])
    //     //
    //     if (list.ok) {
    //         yield put(FullSearchAction.fullFetchResult(list.data));
    //     } else { }
    //     if (stat.ok) {
    //         yield put(FullSearchAction.fullFetchStatResult(stat.data));
    //     } else { }
    // }

    const ONLY_STAT_PAGE_NUM = 1;
    const ONLY_STAT_PAGE_SIZE = 1;
    const [list, stat] = yield all([
        call(api.search, searchKey, activedType, pageNum + 1),
        call(api.searchStat, searchKey, ONLY_STAT_PAGE_NUM, ONLY_STAT_PAGE_SIZE)
    ])
    //
    if (list.ok) {
        yield put(FullSearchAction.fullFetchResult(list.data));
    } else { }
    if (stat.ok) {
        yield put(FullSearchAction.fullFetchStatResult(stat.data));
    } else { }

}
